import { useMemo, useState } from 'react';
import './style.css';

const MAX_LINES = 4;
const TextArea = ({
	onChange,
	onKeyPress,
	onKeyDown,
	name,
	label,
	value,
	placeholder,
	defaultValue,
	textAreaRef,
	maxlength = 500,
	isCountOfCharsVisible = false, //Shows at the bottom of the TextArea how many characters were written out of the maximum
}) => {
	const [text, setText] = useState('');
	const rows = useMemo(() => {
		//count rows from text state
		const lines = text.split(/\r*\n/);
		return lines.length < MAX_LINES ? lines.length : MAX_LINES;
	}, [text]);
	const _handelOnChangeMiddlewarew = e => {
		setText(e.target.value);
		if (onChange && typeof onChange === 'function') onChange(e);
	};

	return (
		<div className={`TextArea`}>
			{label && <label>{label}</label>}
			<div className="TextArea__wrapper">
				<textarea
					onChange={_handelOnChangeMiddlewarew}
					onKeyDown={onKeyDown}
					onKeyPress={onKeyPress}
					name={name}
					value={value}
					maxLength={maxlength}
					placeholder={placeholder}
					defaultValue={defaultValue}
					rows={rows}
					ref={textAreaRef}
				/>
			</div>
			{isCountOfCharsVisible && (
				<div className="TextArea__count_chars">
					{text.length}/{maxlength}
				</div>
			)}
		</div>
	);
};

export default TextArea;
